import { useTranslation } from 'react-i18next';

import Warning from '@/assets/icons/warning.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';

import styles from './SmoltReportPdfNote.module.scss';

interface SmoltReportPdfNoteProps {
    hasWarnings: boolean;
}

export default function SmoltReportPdfNote(props: SmoltReportPdfNoteProps) {
    const { hasWarnings } = props;
    const { t } = useTranslation();

    if (!hasWarnings) {
        return <div className={styles.emptyNote} />;
    }

    return (
        <div className={styles.warningNote}>
            <SvgIcon icon={Warning} size="custom" customSize={14} />
            <span>{t('smoltReport.detailView.warningNote')}</span>
        </div>
    );
}
